import { render, staticRenderFns } from "./NotasForm.vue?vue&type=template&id=10a575b6"
import script from "./NotasForm.vue?vue&type=script&lang=js"
export * from "./NotasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports